import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '../../../../src/web/utils/react';
import unitIcon from './unit.svg';
import style from './UnitSize.scss';
import ApplicableFees from '../../stateful/ApplicableFees';

const propTypes = {
  name: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  price: PropTypes.any.isRequired,
};

const UnitSize = ({ name, price, facility, siteUnitCategoryId }) => {
  // Define feeFilter inside the component to access props
  const feeFilter = {
    facilityId: facility?.id,
    unitSummaryId: siteUnitCategoryId,
  };

  return (
    <div>
      <div>
        <img
          src={unitIcon}
          alt={name}
          type="image/svg+xml"
          width={18.75}
          height={13.5}
        />
        <span className={style.topText}>{name}</span>
      </div>
      <div className={style.littleText}>
        {price === 'Prices' ? 'Call For' : 'starting at'}
      </div>
      <div className={style.bigMoney}>
        {price === 'Prices' ? price : `$${Math.round(price)}`}
      </div>
      <ApplicableFees
        facility={facility}
        feeFilter={feeFilter}
        feesLinkClass={style.applicableFeesLink}
        applicableFeesDownArrowClass={style.applicableFeesDownArrow}
      />
    </div>
  );
};


UnitSize.propTypes = propTypes;

export default pure()(UnitSize);
